
import collect from 'collect.js'
import Stopwatch from '@/assets/icons/fontawesome/duotone/stopwatch.svg?inline'

export default {
  components: {
    Stopwatch,
  },
  props: {
    response: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hotel: null,
      place: null,
      destination: null,
    }
  },
  async fetch() {
    if (
      this.response.search.type === 'geoloc' &&
      this.response.search.place_id
    ) {
      await this.$axios
        .$get('/v3/services/place/details', {
          params: {
            place_id: this.response.search.place_id,
          },
        })
        .then((response) => {
          this.place = response.result
        })
        .catch(() => {})
    }

    if (this.response.search.type === 'location' && this.response.search.ids) {
      await this.$axios
        .$get(`/v3/destinations/${this.response.search.ids}`, {
          params: {
            country: true,
            place: true,
          },
        })
        .then((response) => {
          this.destination = response.data
        })
        .catch(() => {})
    }

    if (
      this.$route.query.hotel_id ||
      (this.response.search.type === 'hotel' && this.response.search.ids)
    ) {
      await this.$axios
        .$get(
          `/v3/${this.aggregator}/hotels/${
            this.$route.query.hotel_id || this.response.search.ids
          }`,
          {
            params: {
              country: true,
              city: true,
              images: true,
              image: true,
            },
          },
        )
        .then((response) => {
          this.hotel = response.data
        })
        .catch(() => {})
    }
  },
  computed: {
    aggregator() {
      return this.response.search.aggregator
    },
    query() {
      return collect(this.response.search)
        .only([
          'check_in',
          'check_out',
          'guests',
          'country',
          'currency',
          'radius',
          'latitude',
          'longitude',
        ])
        .all()
    },
    path() {
      if (this.aggregator === 'innstant' && this.destination) {
        return this.localePath({
          name: 'hotels-destination-countrySlug-destinationSlug-results',
          params: {
            countrySlug: this.destination.country.slug,
            destinationSlug: this.destination.slug,
          },
          query: this.query,
        })
      }

      if (this.aggregator === 'travolutionary' && this.place) {
        return this.localePath({
          name: 'hotels-place-placeId-results',
          params: {
            placeId: this.place.place_id,
          },
          query: this.query,
        })
      }

      return null
    },
    hotelPath() {
      if (this.aggregator === 'innstant' && this.hotel) {
        return this.localePath({
          name: 'hotels-destination-countrySlug-destinationSlug-hotelSlug',
          params: {
            countrySlug: this.hotel.country.slug,
            destinationSlug: this.hotel.city.slug,
            hotelSlug: this.hotel.slug,
          },
          query: this.query,
        })
      }

      if (this.aggregator === 'travolutionary' && this.hotel) {
        return this.localePath({
          name: 'hotels-place-countrySlug-hotelId',
          params: {
            countrySlug: this.hotel.country.slug,
            hotelId: this.hotel.id,
          },
          query: this.query,
        })
      }

      return null
    },
  },
}
